import { render, staticRenderFns } from "./Inout.vue?vue&type=template&id=52c7d21a&scoped=true"
import script from "./Inout.vue?vue&type=script&lang=js"
export * from "./Inout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7d21a",
  null
  
)

export default component.exports